import InputForecast from "@/components/sales-forecast/input-forecast/SalesForecastInput.vue";
import InputForecastAdd from "@/components/sales-forecast/input-forecast/SalesForecastInputAdd.vue";
 import InputForecastDetail from "@/components/sales-forecast/input-forecast/SalesForecastInputDetail.vue";
import InputForecastEdit from "@/components/sales-forecast/input-forecast/SalesForecastInputEdit.vue";
// import SalesUpload from "@/components/master/sales/SalesUpload.vue";

let routesInputForecast = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "InputForecastIndex",
        component: InputForecast
      },
      {
        path: 'add',
        meta: {
          title: "Sales System",
        },
        name: "InputForecastAdd",
        component: InputForecastAdd
      },
    
      {
        path: 'edit/:id',
        meta: {
          title: "Sales System",
        },
        name: "InputForecastEdit",
        component: InputForecastEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Sales System",
        },
        name: "InputForecastDetail",
        component: InputForecastDetail
      },
    
      // {
      //   path: 'upload',
      //   meta: {
      //     title: "Sales System",
      //   },
      //   name: "SalesUpload",
      //   component: SalesUpload
      // },
  ]
  
  export default routesInputForecast
  